import script from "./AskForDetailNode.vue?vue&type=script&setup=true&lang=js"
export * from "./AskForDetailNode.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__